import React from 'react';
import './section5-card.css'
import arr from '../../asserts/arr.png'
const Sec5card = (props) => {
    return ( <>
    <div className='sec5-card-div'>
        <img className='arr' src={arr} alt="" />
    <p className='arr-text'>
{props.sec5card}
    </p></div>
    </> );
}
 
export default Sec5card;